import React from 'react'
import './style.scss'
import { OfferMeta } from '../../../../types/conversions'
const OfferLayout: React.FC<{ onBackClick: () => void, children: React.ReactNode, meta: OfferMeta }> = ({ onBackClick, children, meta }) => {
    return (
        <div className="offer-view pb-5">
            <div className="offer-nav">
                <button onClick={onBackClick} className="offer-nav-back">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path fillRule="evenodd" clipRule="evenodd" d="M10.5303 5.46967C10.8232 5.76256 10.8232 6.23744 10.5303 6.53033L5.81066 11.25H20C20.4142 11.25 20.75 11.5858 20.75 12C20.75 12.4142 20.4142 12.75 20 12.75H5.81066L10.5303 17.4697C10.8232 17.7626 10.8232 18.2374 10.5303 18.5303C10.2374 18.8232 9.76256 18.8232 9.46967 18.5303L3.46967 12.5303C3.17678 12.2374 3.17678 11.7626 3.46967 11.4697L9.46967 5.46967C9.76256 5.17678 10.2374 5.17678 10.5303 5.46967Z" fill="var(--dark)" />
                    </svg>
                </button>
            </div>
            <div className={`color-blur ${meta.style}`}></div>
            <div className="offer-content position-relative">
                <div className={`offer-header mb-4 ${meta.style} d-flex justify-content-center align-items-center flex-column`}>
                    <img src={meta.icon} alt={meta.title} className="offer-icon" />
                    <div className="offer-title text-center">
                        GET EXTRA BONUS
                    </div>
                    <span className='offer-header-text'>{meta.bonux_text}</span>
                </div>
                {children}
            </div>
        </div>
    )
}

export default OfferLayout